<template>
  <section class="survey-prompts" aria-labelledby="survey-prompts-title">
    <h3 id="survey-prompts-title">Survey prompts</h3>
    <p>Help rate each Google LSA lead from 1 (very satisfied) to 5 (very dissatisfied). These prompts do not change High Value.</p>
    <p v-if="loading" role="status">Loading survey prompts…</p>
    <template v-if="loaded">
      <div class="survey-fields">
        <label>
          <span>Which requests are a good match for your business?</span>
          <textarea v-model="services" rows="6" maxlength="20000" :disabled="saving" @input="notice = ''"></textarea>
        </label>
        <label>
          <span>Which requests are not a match?</span>
          <textarea v-model="nonServices" rows="6" maxlength="20000" :disabled="saving" @input="notice = ''"></textarea>
        </label>
      </div>
      <div class="survey-footer">
        <p>Saving prompts applies to future surveys. It does not change past ratings or send a survey.</p>
        <button type="button" :disabled="saving" @click="save">{{ saving ? 'Saving…' : 'Save survey prompts' }}</button>
      </div>
    </template>
    <p v-if="notice" class="survey-notice" role="status">{{ notice }}</p>
    <v-alert v-if="error" dense type="error" role="alert">{{ error }}</v-alert>
    <button v-if="error && !saving && !loading" type="button" @click="load">Reload survey prompts</button>
  </section>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SurveyRulePrompts',
  data() {
    return { loading: false, loaded: false, saving: false, services: '', nonServices: '', revisions: {}, error: '', notice: '' }
  },
  computed: {
    url() { return `${process.env.VUE_APP_API_ENDPOINT}/optimization/accounts/${this.$store.state.me.me.id}` },
    options() { return { headers: { Authorization: 'Bearer ' + this.$store.state.auth.jwt }, timeout: 30000 } }
  },
  mounted() { this.load() },
  methods: {
    async load() {
      if (this.loading || this.saving) return
      this.loading = true
      this.error = ''
      this.notice = ''
      try {
        const { data } = await axios.get(this.url + '/chat-context', this.options)
        const services = data.fields.auto_survey_services
        const exclusions = data.fields.auto_survey_non_services
        this.services = services.value || ''
        this.nonServices = exclusions.value || ''
        this.revisions = { auto_survey_services: services.revision, auto_survey_non_services: exclusions.revision }
        this.loaded = true
      } catch (error) {
        this.error = (error.response && error.response.data && error.response.data.message) || 'Could not load survey prompts. Please try again.'
      } finally { this.loading = false }
    },
    async save() {
      if (this.saving || this.loading || !this.loaded) return
      this.saving = true
      this.error = ''
      this.notice = ''
      let savedFields = 0
      try {
        for (const [field, value] of [['auto_survey_services', this.services], ['auto_survey_non_services', this.nonServices]]) {
          const { data } = await axios.post(this.url + '/chat-update', {
            request_id: crypto.randomUUID(), field, value, mode: 'replace', revision: this.revisions[field]
          }, this.options)
          this.revisions[field] = data.revision
          savedFields++
        }
        this.notice = 'Survey prompts saved.'
      } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || 'Could not save survey prompts. Please try again.'
        this.error = (savedFields ? 'The matching-request prompt was saved, but the exclusions were not. ' : '') + message
      } finally { this.saving = false }
    }
  }
}
</script>

<style scoped>
.survey-prompts { border-top: 1px solid #d1d5db; padding: 16px; }
h3 { margin: 0 0 4px; font-size: 13px; font-weight: 700; color: #111827; }
p { margin: 0 0 12px; font-size: 12px; line-height: 1.5; color: #6b7280; }
.survey-fields { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px; }
label { display: flex; flex-direction: column; gap: 6px; min-width: 0; font-size: 12px; font-weight: 700; color: #374151; }
textarea { width: 100%; padding: 10px 12px; border: 1px solid #d1d5db; border-radius: 8px; background: #fff; font-size: 13px; font-weight: 400; line-height: 1.5; color: #374151; resize: vertical; }
textarea:focus { outline: none; border-color: #63c6a8; box-shadow: 0 0 0 2px rgba(99, 198, 168, .15); }
.survey-footer { display: grid; gap: 12px; margin-top: 16px; }
button { justify-self: end; padding: 8px 12px; border: 1px solid #63c6a8; border-radius: 8px; background: #63c6a8; font-size: 12px; font-weight: 700; color: #fff; }
button:focus-visible { outline: 2px solid #276472; outline-offset: 3px; }
button:disabled, textarea:disabled { opacity: .55; cursor: not-allowed; }
.survey-notice { color: #15803d; margin-top: 12px; }
@media (max-width: 600px) {
  .survey-fields { grid-template-columns: 1fr; }
  button { width: 100%; }
}
</style>
